import React from "react";
import { Loader } from "./loader.component";
import cx from "classnames";

function Button({
  label = "Button",
  disabled = false,
  isLoading = false,
  outlined = false,
  large = false,
  className = "",
  flat = false,
  btnColor,
  onClick = (value) => {},
}) {
  if (isLoading) {
    return <Loader />;
  }

  let defaultState = "bg-theme-primary text-white";
  if (flat) {
    defaultState =
      "bg-white border-white text-theme-primary hover:border-theme-primary";
  }
  if (btnColor === "red") {
    defaultState = "bg-vitalize-red border-vitalize-red text-white";
  }

  return (
    <button
      disabled={disabled}
      //
      className={cx("text-white btn-primary py-2 px-4 rounded " + className, {
        "cursor-not-allowed": disabled,
      })}
      onClick={onClick}>
      {label}
    </button>
  );
}

export { Button };
